import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { RichTextBox } from "../../components/richtext/RichTextBox";
import EventService from "../../services/eventService";
import Utils from "../../utils/utils";
import { useTranslationEx } from "../../hooks/useTranslationEx";

const Event: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { t2 } = useTranslationEx({
    entityType: "Event",
    entityId: id || "",
  });
  const [event, setEvent] = useState<{
    title: string;
    startTime: string | null;
    endTime: string | null;
    post: any;
    thumbnail: string;
  } | null>(null);

  useEffect(() => {
    // Fetch API data
    EventService.getEventDetail(id)
      .then((data) => {
        if (data) {
          setEvent({
            title: data.title,
            startTime: data.startDate || null,
            endTime: data.endDate || null,
            post: data.post,
            thumbnail: data.thumbnail,
          });
        }
      })
      .catch((error) => console.error("Error fetching event:", error));
  }, []);

  // Validate and format date
  const formatEventTime = (time: string | null) => {
    if (!time) return "N/A";
    const parsedDate = new Date(time);
    if (isNaN(parsedDate.getTime())) return "N/A";
    return Utils.formatDate(parsedDate);
  };

  if (!event) {
    return null;
  }

  return (
    <div className="mx-auto mt-[1.875rem] max-w-[50rem] p-[1.875rem]">
      <h2 className="mb-[0.625rem] text-[1.5rem] font-semibold leading-[2.0431rem]">
        {t2(event.title)}
      </h2>
      <p className="mb-[1.875rem] text-base font-normal leading-[1.25rem] text-[#5E6D77]">
        {formatEventTime(event.startTime)} ~{" "}
        {event.endTime ? formatEventTime(event.endTime) : ""}
      </p>
      <RichTextBox richtext={event?.post?.richtext} />
    </div>
  );
};

export default Event;
